import _ from 'underscore';
import { columnConfigToColumnChooserConfig, isConversionsColumnAllowed } from '../../column-config-to-chooser-config';
import { getCampaignLabelColumnConfig } from './campaign-grid-column-config';
import { Constants } from '../../constants';

export function getCampaignLabelsGridConfig({
  i18n,
  newI18n,
  jsDataCampaign,
  edm,
  LabelCampaignSchema,
  getCurrentLevel,
  globalConfig,
  deleteSchema,
  bingadsGridColumn,
  gridType,
  isForVNext,
}) {
  const campaignLabelColumnConfig = getCampaignLabelColumnConfig({
    i18n,
    bingadsGridColumn,
    globalConfig,
    newI18n,
  });

  const {
    IsViewThroughConversionEnabled,
    IsAvgPositionDeprecationPhase1Enabled,
    // IsViewThroughConversionsRevenueEnabled,
  } = globalConfig.get('Permissions') || {};
  // (youngim) MT bug needs to be fixed for dimensinos
  const IsViewThroughConversionsRevenueEnabled = false;

  const level = getCurrentLevel();
  return {
    getColumns: () => campaignLabelColumnConfig.getLevelOfDetailColumns()
      .concat(campaignLabelColumnConfig.getPerfColumns())
      .concat(campaignLabelColumnConfig.getConversionColumns()),
    getColumnChooserConfiguration: () => {
      const lockedColumns = ['LabelName'];

      const columnChooserConfig = {
        categories: [{
          name: i18n.getString('LevelOfDetail'),
          options: columnConfigToColumnChooserConfig(
            campaignLabelColumnConfig.getLevelOfDetailColumns(),
            lockedColumns
          ),
        }, {
          name: i18n.getString('Performance'),
          options: columnConfigToColumnChooserConfig(
            campaignLabelColumnConfig.getPerfColumns(),
            lockedColumns
          ),
        }, {
          name: i18n.getString('Conversions'),
          options: columnConfigToColumnChooserConfig(
            _.filter(
              campaignLabelColumnConfig.getConversionColumns(),
              ({ name }) => isConversionsColumnAllowed({
                name,
                IsViewThroughConversionEnabled,
                IsViewThroughConversionsRevenueEnabled,
              })
            ),
            lockedColumns
          ),
        }],
        selected: lockedColumns.concat(_.compact([
          IsAvgPositionDeprecationPhase1Enabled && 'TopImpressionRate',
          IsAvgPositionDeprecationPhase1Enabled && 'AbsoluteTopImpressionRate',
        ])),
        mandatory: [],
        patchQuery: true,
        isForVNext,
      };

      if (isForVNext) {
        columnChooserConfig.customToolbarIcon = 'ba-TripleColumnSolid';
      }

      return columnChooserConfig;
    },

    getEntity: () => jsDataCampaign.Time,

    getEntitySet: () => _.result(edm.currentAccount, 'Time'),

    getSchema: () => {
      const columns = ['CampaignName', 'AdGroupName'];

      deleteSchema(columns, LabelCampaignSchema);

      if (level === Constants.AccountLevel) {
        LabelCampaignSchema.properties.CampaignName = { // eslint-disable-line no-param-reassign
          type: 'string',
          filterable: true,
          nullable: true,
        };
        LabelCampaignSchema.properties.AdGroupName = { // eslint-disable-line no-param-reassign
          type: 'string',
          filterable: true,
          nullable: true,
        };
      } else if (level === Constants.CampaignLevel) {
        LabelCampaignSchema.properties.AdGroupName = { // eslint-disable-line no-param-reassign
          type: 'string',
          filterable: true,
          nullable: true,
        };
      }

      return LabelCampaignSchema;
    },
    getReportName: () => 'CampaignLabelReport',
    getReportSchema() {
      return _.defaults({
        name: this.getReportName(gridType),
      }, this.getSchema(gridType));
    },
    modifyFilter: filters => filters,
    getRewriteMap: () => ({
      StartTime: i18n.getString('ColumnName_StartTime'),
      EndTime: i18n.getString('ColumnName_EndTime'),
      AreaCode: i18n.getString('ColumnName_AreaCode'),
      City: i18n.getString('ColumnName_City'),
      StateOrProvince: i18n.getString('ColumnName_StateOrProvince'),
      CallStatus: i18n.getString('ColumnName_CallStatus'),
      CallDuration: i18n.getString('ColumnName_CallDuration'),
      PhoneSpend: i18n.getString('ColumnName_PhoneSpend'),
      AdGroupName: i18n.getString('FilterLocalization_DataAttribute_AdGroupName'),
      CampaignName: i18n.getString('FilterLocalization_DataAttribute_CampaignName'),
    }),
  };
}
